import React from 'react'
import classNames from 'classnames'
import { TableCell } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { brandColors } from 'transfix-ui'
import { formatLocation, formatPuDelTime } from '../utils/formatHistoricalQuotesTableContents'

interface ILocationTimeCellProps {
  city?: string | null
  stateCode?: string | null
  date?: string | null
  zip?: string | null
  time?: string | null
  className?: string
  additionalStops?: number | null
}

const useStyles = makeStyles(() => ({
  dataAvailable: {
    color: brandColors.coolGray5,
    fontSize: 11,
  },
  dataUnavailable: {
    color: brandColors.coolGray4,
    fontSize: 11,
  },
  additionalStops: {
    fontWeight: 'bold',
  },
}))

export function LocationTimeCell({
  additionalStops,
  city,
  className,
  date,
  stateCode,
  time,
  zip,
}: ILocationTimeCellProps) {
  const classes = useStyles()
  const location = formatLocation(city, stateCode, zip)
  const [displayDate, displayTime] = formatPuDelTime(date, time)
  const sqtObjectiveFourEnabled = useFeatureFlag('sqtObjectiveFour')
  const dateClass = classNames({
    [classes.dataAvailable]: displayDate !== 'No Appointment Available',
    [classes.dataUnavailable]: displayDate === 'No Appointment Available',
  })
  const displayClass = classNames({
    [classes.dataAvailable]: displayTime !== 'No Time Available',
    [classes.dataUnavailable]: displayTime === 'No Time Available',
  })
  const hasAdditionalStops = Number(additionalStops) > 0

  return (
    <TableCell className={className || ''}>
      <div>
        {location}
        {hasAdditionalStops && sqtObjectiveFourEnabled && (
          <span className={classes.additionalStops}>{` +${additionalStops}`}</span>
        )}
      </div>
      <div>
        <span className={dateClass}>{displayDate}</span>
        {displayTime !== '' && <span className={displayClass}> {displayTime}</span>}
      </div>
    </TableCell>
  )
}
